<template>
  <v-dialog
    v-model="isDialogVisible"
    width="50%"
    @click:outside="onHandleDialogCancel"
    @keydown.esc="onHandleDialogCancel"
  >
    <v-card>
      <v-toolbar
        color="blue-grey-darken-2"
      >
        <v-card-title>
          {{ !headline ? getDefaultHeadline : headline }}
        </v-card-title>
      </v-toolbar>

      <v-col
        class="px-8 pt-4"
        cols="12"
      >
        {{ !text ? getDefaultText : text }}
        <div class="formatted-text-box mt-2 scrollable-small">{{ selectedCardsToDelete }}</div>
      </v-col>
      <v-card-actions>
        <v-row
          align="center"
          justify="center"
          no-gutters
        >
          <v-btn
            color="primary"
            variant="text"
            @click="onHandleDialogCancel"
          >
            {{ $t('CardDialogs.button_cancel') }}
          </v-btn>
          <v-btn
            color="primary"
            variant="text"
            @click="onHandleDialogDeleteConfirm"
          >
            {{ $t('CardDialogs.button_confirm') }}
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import {
  computed,
  onMounted,
  onUnmounted,
  ref,
} from 'vue'
import type { PropType } from 'vue';

import {
  useI18n
} from '@/composables/useI18n';

const {
  t,
} = useI18n();

const props = defineProps({
  selectedNumbers: {
    type: Array as PropType<number[]>,
    default() {
      return []
    }
  },
  headline: {
    required: false,
    type: String as PropType<string>,
    default: '',
  },
  text: {
    required: false,
    type: String as PropType<string>,
    default: '',
  }
})

const emits = defineEmits([
  'onDialogCancel',
  'onDialogConfirm'
])

const isDialogVisible = ref<boolean>(false);

const selectedCardsToDelete = computed(
  () => props.selectedNumbers?.join(', ')
)

const getDefaultText = computed(
  () => t('CardDialogs.delete_items.text', { count: props.selectedNumbers.length })
);

const getDefaultHeadline = computed(
  () => t('CardDialogs.delete_items.headline')
);

const onHandleDialogCancel = () => {
  isDialogVisible.value = false;
  emits('onDialogCancel');
};

const onHandleDialogDeleteConfirm = () => {
  isDialogVisible.value = false;
  emits('onDialogConfirm');
};

onMounted(() => {
  isDialogVisible.value = true;
});

onUnmounted(() => {
  isDialogVisible.value = false;
})
</script>

